import React from 'react';

export default function DoubleCheck(props: React.SVGAttributes<{}>) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.5003 3.5L4.08366 9.91667L1.16699 7M12.8337 5.83333L8.45866 10.2083L7.58366 9.33333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
